// removed by extract-text-webpack-plugin
module.exports = {"onboarding":"OnboardingDialog__onboarding___1gSfe","swiperSlide":"OnboardingDialog__swiperSlide___wera3","textSlide":"OnboardingDialog__textSlide___yjXT6","error":"OnboardingDialog__error___2-8py","inviteInfo":"OnboardingDialog__inviteInfo___3xyGp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OnboardingDialog/OnboardingDialog.scss
// module id = 1189
// module chunks = 1